import { Tooltip } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

export const DynamicToolTip: React.FC<{
  text: React.ReactNode;
  lineClamp: number;
}> = ({ text: tooltip, lineClamp }) => {
  const headerRef = useRef<HTMLTableCellElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      const header = headerRef.current;
      if (header) {
        setIsOverflowing(header.scrollHeight > header.clientHeight);
      }
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);

    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, []);

  return (
    <Tooltip
      title={isOverflowing ? tooltip : ''}
      disableHoverListener={!isOverflowing}
    >
      <div
        ref={headerRef}
        style={{
          display: '-webkit-box',
          overflow: 'hidden',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: lineClamp,
          whiteSpace: 'normal'
        }}
      >
        {tooltip}
      </div>
    </Tooltip>
  );
};
